import { render, staticRenderFns } from "./multipane.vue?vue&type=template&id=39996333&"
import script from "./multipane.vue?vue&type=script&lang=js&"
export * from "./multipane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports